<template>
  <v-container class="main-container responsive-height create-investor-account-wrapper">
    <v-row>
      <v-col cols="12">
        <div class="middle-bar">
          <div class="titleName mb-1">
            <v-icon class="mr-2" color="#5F7692">mdi-bag-checked</v-icon>
            <span class="text--ash">Managers</span>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-skeleton-loader v-if="isInitialLoading" type="card" class="mt-5 ml-3" :loading="true" width="300"></v-skeleton-loader>
      <v-col md="6" sm="6" lg="3" v-if="!isInitialLoading" v-for="manager in managers" :key="manager.id">
        <v-card class="elevation-0 rounded-0 transition-method-card investor-card"
          :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">

          <v-card flat class="profile-card rounded-0" :color="$vuetify.theme.dark ? '#172233' : 'transparent'">
            <div class="user-profile">
              <div class="profile-image">
                <v-badge avatar bordered overlap color="black accent-4" icon="mdi-star-outline">
                  <v-avatar size="59">
                    <v-img src="@/assets/avatar.png"></v-img>
                  </v-avatar>
                </v-badge>
              </div>
              <div class="profile-text">
                <span>{{ manager.account_no }}</span>
                <span>{{ manager.username }}</span>
              </div>
            </div>
          </v-card>
          <v-card-actions>
            <div class="value">
              <span>Total Investors</span>
              <span>{{ manager.investors }}</span>
            </div>
            <v-spacer></v-spacer>
            <div class="value">
              <span>Age (day)</span>
              <span>{{ manager.age }}</span>
            </div>
          </v-card-actions>
          <v-card-actions>
            <v-sheet :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'">
              <div>
                <apexChart width="80%" height="95px" type="line" :options="options" :series="series">
                </apexChart>
              </div>
            </v-sheet>
          </v-card-actions>

          <v-card-actions class="pb-0 pt-3">
            <v-btn tile outlined block large :to="`/manager-details?id=${manager.id}&account=${manager.trading_acc}`"
              elevation="0" class="text-capitalize btn-account" color="#B4C2D1">See Details</v-btn>

          </v-card-actions>
        </v-card>
      </v-col>
      <v-col v-if="!isInitialLoading && managers.length === 0" class="text-center">
        <p class="text--ash">No Managers Found</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { TRADEMASTER__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      options: {
        chart: {
          type: "line",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          labels: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        grid: {
          show: false,
        },
        stroke: {
          width: 2,
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#3A648E"],
      },
      series: [
        {
          name: "Series 1",
          data: [45, 52, 38, 45, 19, 23, 2],
        },
      ],
      isInitialLoading: true
    }
  },

  computed: {
    ...mapState("trademaster", ["managers"]),
  },

  methods: {
    ...mapActions("trademaster", [
      TRADEMASTER__ACTIONS.GETALLMANAGER,
    ]),

    async getManager() {
      this.isInitialLoading = true;
      try {
        await this[TRADEMASTER__ACTIONS.GETALLMANAGER]();
      } catch (error) {
        console.error('Error loading messages:', error);
      } finally {
        this.isInitialLoading = false;
      }
    }
  },

  async mounted() {
    this.getManager();
  }
};
</script>
